<section class="p-6 pb-0">

  <div class="grid grid-cols-3 gap-6 mb-6">

    <!-- Person Contact -->
    <div class="col-span-3 xl:col-span-1 order-last lg:order-first">

      <!--
      <div class="card mb-6">
        <dl class="flex flex-wrap">

          <div class="flex-auto  pl-6 pt-6">
            <h2 class="text-xl font-semibold">Tagline</h2>
          </div>

          <div *ngIf="reportSearch" class="flex items-center w-full flex-none gap-x-4 border-t border-gray-900/5 dark:border-[#3c4377] px-6 pt-6 mt-6">
            <p *ngIf="reportSearch.search_person" class="text-md text-secondary-900 dark:text-white">
              <span *ngIf="reportSearch?.search_person?.tagline && reportSearch?.search_person?.tagline != '[]'">{{ reportSearch?.search_person?.tagline }}</span>
              <span *ngIf="reportSearch?.search_person?.tagline && reportSearch?.search_person?.tagline === '[]'">No tags could be found.</span>
            </p>
          </div>

        </dl>
        <div class="py-3"></div>
      </div>
      -->

      <app-person-contact (editContactModalRequested)="editContactModalRequested.emit($event)"></app-person-contact>
    </div>
    <!-- Person / Contact -->

    <!-- Person Insights -->
    <div class="grid col-span-3 xl:col-span-2 order-first lg:order-last h-full gap-6">
      <div class="blue-card p-6 self-start relative fix-height h-full">

        <!-- Edit Prompt
        <button (click)="handleEdit('ASK_ASSISTANT_SALES_INSIGHTS', salesInsights)"
                type="button"
                class="absolute top-1 right-1 rounded-md bg-[#1c9ed1]/10 p-1 text-white hover:bg-opacity-90 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-transparent"
                matTooltip="Edit"
                matTooltipPosition="above"
                matTooltipClass="'custom-tooltip'"
        >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="text-[#1c9ed1] h-3 w-3">
            <path d="M21.731 2.269a2.625 2.625 0 0 0-3.712 0l-1.157 1.157 3.712 3.712 1.157-1.157a2.625 2.625 0 0 0 0-3.712ZM19.513 8.199l-3.712-3.712-12.15 12.15a5.25 5.25 0 0 0-1.32 2.214l-.8 2.685a.75.75 0 0 0 .933.933l2.685-.8a5.25 5.25 0 0 0 2.214-1.32L19.513 8.2Z" />
          </svg>
        </button>
        -->
        <!-- / Edit Prompt -->

        <dl class="flex flex-wrap">
          <div class="flex justify-between w-full mb-4">
            <h2 class="text-xl text-secondary-900 dark:text-white font-semibold">Approach suggestions</h2>
            <div>
              <svg viewBox="0 0 15 20" class="w-6 h-6" fill="none">
                  <path d="M6.5 6C5.94772 6 5.5 6.44772 5.5 7C5.5 7.55228 5.94772 8 6.5 8H8.5C9.05228 8 9.5 7.55228 9.5 7C9.5 6.44772 9.05228 6 8.5 6H6.5Z" fill="#1B9ED1"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M10.5 16V13.3264C12.8649 12.2029 14.5 9.7924 14.5 7C14.5 3.13401 11.366 0 7.5 0C3.63401 0 0.5 3.13401 0.5 7C0.5 9.7924 2.13505 12.2029 4.5 13.3264V16C4.5 16.5523 4.94772 17 5.5 17H9.5C10.0523 17 10.5 16.5523 10.5 16ZM9.64182 11.5198L8.63107 12H6.36893L5.35818 11.5198C3.66429 10.7152 2.5 8.99156 2.5 7C2.5 4.23858 4.73858 2 7.5 2C10.2614 2 12.5 4.23858 12.5 7C12.5 8.99156 11.3357 10.7152 9.64182 11.5198ZM6.5 15V14H8.5V15H6.5Z" fill="#1B9ED1"/>
                  <path d="M7.5 20C8.60457 20 9.5 19.1046 9.5 18H5.5C5.5 19.1046 6.39543 20 7.5 20Z" fill="#1B9ED1"/>
              </svg>
            </div>
          </div>

          <div *ngIf="company">
            <!--
            <p class="text-md text-secondary-900 dark:text-white">
              {{ company | getAssistantPrompt: 'ASK_ASSISTANT_SALES_INSIGHTS' ?? '' }}
            </p>
            -->

            <div class="mb-8">
              <app-assistant-prompt tag="ASK_ASSISTANT_SALES_INSIGHTS"
                                    title="Approach suggestions"
                                    [type]="'insights'"
                                    [company]="company"
                                    [reportId]="reportSearch?.id"
                                    [showButton]="true"
                                    [buttonType]="1">
              </app-assistant-prompt>
            </div>

            <div>
              <h2 class="text-md text-secondary-900 dark:text-white font-semibold mb-4">{{ reportSearch?.name }}'s personal interests:</h2>
              <app-assistant-prompt tag="ASK_ASSISTANT_INITIAL_OUTREACH"
                                    title="Personal interests"
                                    [type]="'pills'"
                                    [company]="company"
                                    [reportId]="reportSearch?.id">
              </app-assistant-prompt>
            </div>

          </div>
        </dl>

      </div>

      <!--
      <div class="blue-card p-6 h-full relative">
        <dl class="flex flex-wrap">
          <div class="flex justify-between w-full mb-6">
            <h2 class="text-xl text-secondary-900 dark:text-white font-semibold">Personal interests</h2>
            <div>
              <svg viewBox="0 0 15 20" class="w-6 h-6" fill="none">
                <path d="M6.5 6C5.94772 6 5.5 6.44772 5.5 7C5.5 7.55228 5.94772 8 6.5 8H8.5C9.05228 8 9.5 7.55228 9.5 7C9.5 6.44772 9.05228 6 8.5 6H6.5Z" fill="#1B9ED1"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M10.5 16V13.3264C12.8649 12.2029 14.5 9.7924 14.5 7C14.5 3.13401 11.366 0 7.5 0C3.63401 0 0.5 3.13401 0.5 7C0.5 9.7924 2.13505 12.2029 4.5 13.3264V16C4.5 16.5523 4.94772 17 5.5 17H9.5C10.0523 17 10.5 16.5523 10.5 16ZM9.64182 11.5198L8.63107 12H6.36893L5.35818 11.5198C3.66429 10.7152 2.5 8.99156 2.5 7C2.5 4.23858 4.73858 2 7.5 2C10.2614 2 12.5 4.23858 12.5 7C12.5 8.99156 11.3357 10.7152 9.64182 11.5198ZM6.5 15V14H8.5V15H6.5Z" fill="#1B9ED1"/>
                <path d="M7.5 20C8.60457 20 9.5 19.1046 9.5 18H5.5C5.5 19.1046 6.39543 20 7.5 20Z" fill="#1B9ED1"/>
              </svg>
            </div>
          </div>

          <div *ngIf="company">

            <app-assistant-prompt tag="ASK_ASSISTANT_INITIAL_OUTREACH"
                                  title="Personal interests"
                                  [type]="'list'"
                                  [company]="company"
                                  [reportId]="reportSearch?.id">
            </app-assistant-prompt>

          </div>

        </dl>
      </div>
      -->

    </div>
  </div>

  <!--
  <div *ngIf="!isEnriched">

    <app-enrich-profile
      [reportSearch]="reportSearch"
      (profileEnriched)="onProfileEnriched()">
    </app-enrich-profile>

  </div>
  -->

  <!--
  <ng-container *ngIf="isEnriched">
    <div class="animate-fadeIn">
      <app-expertise
        [edit]="edit"
        [reportSearch]="reportSearch"
        [company]="company">
      </app-expertise>
    </div>

    <div class="animate-fadeIn">
      <app-background
        [edit]="edit"
        [reportSearch]="reportSearch"
        [company]="company">
      </app-background>
    </div>
  </ng-container>
  -->

</section>
